"use client"
import { oswald } from "@/app/fonts";
import Image from "next/image";
import ButtonAjouterPanier from "./ButtonAjouterPanier";
import Link from "next/link";
import { useContext } from "react";
import { GlobalContext } from "@/context";
import { toast } from "react-toastify";
import axios from "../../app/lib/axiosInstance"

const ProductInfo = ({ product }) => {

  const { connected,setPanierData } = useContext(GlobalContext);

  const addProductToFavoriteList = async (productId) => {
    if(connected){
      const data = await axios
      .post(
        "/auth/addfavoriteproduct",
        {
          productId: productId,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => res.data)
      .then((res) => toast.success("Produit ajouté aux favoris !"))
      .catch(err=>{    
        toast.error(err.response.data.message)})
    }
   else {
    toast.error("Veuillez vous connecter pour ajouter aux favoris")
  }
  };
  return (
    <div
      className={oswald.className}
      style={{ display: "flex", flexDirection: "column", gap: "6px" }}
    >
      <h2 className="hidden lg:block text-sm font-medium">{product?.brand}</h2>
      <h1 className="hidden lg:block text-[26px] font-medium uppercase">
        {product?.name}
      </h1>
      <div className="flex gap-2 items-center mb-2 cursor-pointer" onClick={()=>addProductToFavoriteList(product._id)}>
        <Image
          src={"/icons/notFavorite.png"}
          height={13}
          width={15}
          className="w-[15px] h-[13px]"
          alt="add-favorite-icon"
        />
        <h2 className="text-sm bg-[">Ajouter aux favoris</h2>
      </div>
      <p className="text-sm">{product?.details}</p>
      {/* <h2 className="text-[12px] underline mb-2">Read More</h2> */}
      <div className="flex items-baseline mb-2">
        {product?.promo ? (
          <h2 className="text-base text-[#C4C4C4] line-through">
            {product?.price}DT
          </h2>
        ) : null}
        <h2 className="text-base">
           <span className="text-2xl">{product?.promo? product?.price-((product?.price/100) *product?.promo):  product?.price}</span>DT
        </h2>
        {product?.promo ? (
          <div className="">
            <h2 className="text-base border-[1px] border-[#000000] px-[14px] py-1 ml-4">
              {product?.promo}% Off
            </h2>
          </div>
        ) : null}
      </div>

      <div className="flex gap-3 mb-2">
        <ButtonAjouterPanier data={product}/>
      </div>

      <div className="flex items-center gap-2 mb-2 ">
        <Image
          src={"/icons/favorite.png"}
          height={14}
          width={16}
          className="w-[16px] h-[14px] cursor-pointer"
          alt="view-favorite-icon"
          onClick={()=>{addProductToFavoriteList(product)}}
        />
        <Link href={"/favorite"} className="underline">Voir ma liste de favoris</Link>
      </div>
      <div className="flex flex-wrap gap-4">
        {product?.categories?.map((el, index) => {
          return <h2 key={index} className="text-sm bg-[#E3E3E3] px-2 py-2">{el}</h2>;
        })}
      </div>
    </div>
  );
};
export default ProductInfo;
